<template>
    <div class="security-header" tabindex="0">
        <span v-if="isJACareerApp" class="security-header__title">JA Future by Design: Careers</span>
        <span v-if="isJAEntrepreApp" class="security-header__title">JA Future by Design: Entrepreneurship</span>
        <img src="~@/core/Images/ja_logo_white.svg" class="security-header__logo" alt="Junior Achievement">
    </div>
</template>

<script>
    export default {
        name: "HeaderSecurity",
    }
</script>

<style lang="stylus" scoped>
    @import "~@/core/Styles/variables.styl"

    .security-header
        background-color color-green-light
        height 60px
        display flex
        align-items center
        justify-content space-between

        &__title
            font font-poppins-semibold
            font-size 16px
            color color-blank
            margin-left 5%

        &__logo
            width 113px
            float right
            margin-right 3%

    @media (min-width: 768px)
        .security-header__title
            font-size 18px

</style>
